import { z } from "zod";
const nullSize = { height: -1, width: -1 };
function isNullSize(size) {
    return size.height === nullSize.height && size.width === nullSize.width;
}
export const Size = z.object({
    width: z
        .number()
        .nullish()
        .transform((v) => v !== null && v !== void 0 ? v : nullSize.width),
    height: z
        .number()
        .nullish()
        .transform((v) => v !== null && v !== void 0 ? v : nullSize.height),
});
export const SizeOrUndefined = Size.optional().transform((v) => {
    if (!v)
        return undefined;
    if (isNullSize(v))
        return undefined;
    return v;
});
